import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SuperadminSidebar from '../../SuperadminDashboard/Sidebar/SuperadminSidebar';
import Topbar from '../../components/common/Topbar/Topbar';
import styles from '../DashboardLayout.module.css';

const SuperadminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className={styles.layout}>
      <SuperadminSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className={styles.mainContent}>
        <Topbar 
          onMenuClick={() => setIsSidebarOpen(true)} 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
        <main className={styles.content}>
          <Outlet context={{ searchQuery }} />
        </main>
      </div>
    </div>
  );
};

export default SuperadminLayout;
